export default __webpack_public_path__ + "static/media/logo.f897eb5d.png";